<template>
  <div id="echarts">
    <div class="wrap">
      <div class="pie" ref="pie"></div>
      <div class="bar" ref="bar"></div>
    </div>
    <div class="doubleBar" ref="doubleBar"></div>
  </div>
</template>

<script>
  import echarts from "echarts/lib/echarts";
  import "echarts/lib/chart/pie"; // 饼图
  import "echarts/lib/chart/bar"; // 柱状图
  import "echarts/lib/component/tooltip"; // 提示框组件
  import "echarts/lib/component/title"; // 标题组件
  import "echarts/lib/component/legend"; // 标签组件
  export default {
    name: "Echarts",
    props: {
      star: {
        type: Array,
        required: true,
        default: () => {
          return new Array(5).fill(0);
        }
      },
      question: {
        type: Object,
        required: true,
        default: () => {
          const arr = new Array(5).fill(0);
          const obj = new Object({
            yes: arr,
            no: arr,
            opt: new Array(5).fill('Question'),
          });
          return obj;
        }
      },
    },
    /*props: ["star", "question"],*/
    data() {
      return {};
    },
    watch: {
      star() {
        this.drawPie(this.star);
        this.drawBar(this.star);
      },
      question: {
        handler() {
          this.drawDoubleBar(this.question);
        },
        deep: true
      }
    },
    created() {
      this.drawPie(this.star);
      this.drawBar(this.star);
      this.drawDoubleBar(this.question);
    },
    methods: {
      drawPie(arr) {
        const starArr = ['一星', '二星', '三星', '四星', '五星'];
        /*const colorArr = ['#ff5722', '#FF00FF', '#ffeb38', '#9B30FF', '#00FF00'];*/
        const colorArr = ['#08cbfe', '#ff5722', '#ffeb38', '#9B30FF', '#ff0302'];
        let data = [];
        let color = [];
          arr.map((item, index)=>{
          if(Number(item) > 0) {
            data.push({ value: item, name: starArr[index] });
            color.push(colorArr[index]);
          }
        });
        this.$nextTick(() => {
          let pieChart = echarts.init(this.$refs["pie"]);
          let pie_option = {
            color,
            title: {
              text: '星级统计',
              x: 'left',
              textStyle: {
                color: "#fff",
              }
            },
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            /*legend: {
              orient: "vertical",
              align: "right",
              left: "right",
              top: "middle",
              data: [
                {
                  name: '一星',
                  textStyle: {
                    color: "#fff",
                  }
                },
                {
                  name: '二星',
                  textStyle: {
                    color: "#fff",
                  }
                },
                {
                  name: '三星',
                  textStyle: {
                    color: "#fff",
                  }
                },
                {
                  name: '四星',
                  textStyle: {
                    color: "#fff",
                  }
                },
                {
                  name: '五星',
                  textStyle: {
                    color: "#fff",
                  }
                },
              ]
            },*/
            series: [{
              name: '评星比例',
              type: 'pie',
              radius: '45%',
              center: ['50%', '50%'],
              data,
              label: {
                show: true,
                position: 'outside',
                formatter: '{b}:{d}%'
              }
            }]
          };
          pieChart.setOption(pie_option);
        });
      },
      drawBar(arr) {
        this.$nextTick(() => {
          let pieChart = echarts.init(this.$refs["bar"]);
          let bar_option = {
            /*title: {
              text: '评星人数',
              left: 'center',
              textStyle: {
                color: "#fff",
              }
            },*/
            // color: ['#08cbfe'],
            color: ['#00FF00'],
            grid: {
              left: '2%',
              right: '10%',
              bottom: '0%',
              containLabel: true,
              // borderColor: "#f00",
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'category',
              name: '星级',
              data: ['一星', '二星', '三星', '四星', '五星'],
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
              axisLabel: {
                interval: 0,
              }
            },
            yAxis: {
              type: 'value',
              name: '人数',
              minInterval: 1,
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
              splitLine: {
                show: false,
              }
            },
            series: [
              {
                name: '人数',
                type: 'bar',
                label: {
                  show: true,
                  // formatter: '{c}人',
                  color: '#fff',
                  position: 'top',
                  fontSize: 14,
                },
                barWidth: '30%',
                data: arr
              },
            ]
          };
          pieChart.setOption(bar_option);
        });
      },
      drawDoubleBar(obj) {
        this.$nextTick(() => {
          let pieChart = echarts.init(this.$refs["doubleBar"]);
          let double_bar_option = {
            title: {
              text: '现象统计',
              // left: 'center',
              left: 'left',
              textStyle: {
                color: "#fff",
              }
            },
            legend: {
              /*orient: "vertical",
              align: "right",
              left: "right",
              top: "middle",*/
              data: [
                {
                  name: '是',
                  textStyle: {
                    color: "#fff",
                  }
                },
                {
                  name: '否',
                  textStyle: {
                    color: "#fff",
                  }
                }
              ]
            },
            grid: {
              left: '0%',
              right: '5%',
              bottom: '0%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'category',
              name: '现象',
              data: obj.opt,
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
              axisLabel: {
                interval: 0,
                rotate: 40
              }
            },
            yAxis: {
              type: 'value',
              name: '人数',
              minInterval: 1,
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
              splitLine: {
                show: false,
              }
            },
            series: [
              {
                name: '是',
                type: 'bar',
                barGap: 0,
                color: ['#08cbfe'],
                label: {
                  show: true,
                  // formatter: '{c}人',
                  color: '#fff',
                  position: 'top',
                  fontSize: 8,
                },
                barWidth: '15%',
                data: obj.yes
              },
              {
                name: '否',
                type: 'bar',
                barGap: 0,
                color: ['#ff0302'],
                label: {
                  show: true,
                  // formatter: '{c}人',
                  color: '#fff',
                  position: 'top',
                  fontSize: 8,
                },
                barWidth: '15%',
                data: obj.no
              },
            ]
          };
          pieChart.setOption(double_bar_option);
        });
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  #echarts {
    width: 100%;
    height: 560px;
    .wrap {
      width: 100%;
      height: 230px;
      margin: 0 0 30px 0;
      display: flex;
      .pie {
        width: 40%;
        height: 100%;
        border-right: 1px solid $color_white;
        box-sizing: border-box;
      }
      .bar {
        width: 58%;
        height: 100%;
        margin: 0 0 0 2%;
      }
    }
    .doubleBar {
      height: 300px;
    }
  }
</style>